import { render, staticRenderFns } from "./MessageSystem.vue?vue&type=template&id=cde0d65a&scoped=true&"
import script from "./MessageSystem.vue?vue&type=script&lang=js&"
export * from "./MessageSystem.vue?vue&type=script&lang=js&"
import style0 from "./MessageSystem.vue?vue&type=style&index=0&id=cde0d65a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cde0d65a",
  null
  
)

export default component.exports